import styled from 'styled-components'

const white = '#FFF'
const red = '#B41400'
const grey = '#F2F2F2'
const black = '#000'

export const StyledRelatedInArticle = styled.div`
    background-color:${grey};
    width:100%;
    padding:15px;
    margin-bottom: 20px;
`

export const StyledHeadlineDiv = styled.div`
        padding-left: 15px;
        width: 100%;
        h3 {
            font-size: 16px !important;
            color: ${black};
            line-height: 22px;
            padding-top:5px;
        }
        h4 {
            color:${red};
            font-size:17px  !important;
            margin-top: 0px !important;
            margin-bottom: 0px !important;
            text-transform: uppercase;
        }
`
export const StyledBoxDiv = styled.div`
        a {
            display:flex;
            align-items: flex-start;
            color:${black} !important;
        }

`
export const StyledInnerDiv = styled.div`
    background-color:${white};
    padding: 15px;
    position: relative;
    article {
        display: flex;
    }
    picture {
        max-width: 40%;
        img {
            margin: 0 !important;
        }
    }
    span {
        position: relative;
        right: 0;
        margin-top: 5px;
        text-transform: uppercase;
        float: right;
        font-size: 13px;
        line-height: 1;
    }
`
